const development_tenant = {
    notification: '你处于开发模式',
};
export default Object.freeze(development_tenant);
